<script lang="ts" setup>
defineProps<{
  author?: string;
}>();

defineSlots<{
  default: () => VNode[];
}>();
</script>

<template>
  <div class="contentQuote">
    <span class="contentQuote__mark">„</span>
    <div class="contentQuote__text">
      <slot />
    </div>
    <span v-if="author" class="contentQuote__author">{{ author }}</span>
  </div>
</template>

<style lang="scss">
.contentQuote {
  border-left: 3px solid #8583ba;
  padding: 16px 20px;
  margin: 0 0 40px;
  position: relative;

  &__mark {
    position: absolute;
    top: -20px;
    left: 10px;
    font-size: 32px;
    line-height: 1;
    color: #8583ba;
    font-family: serif;
    pointer-events: none;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #121212;

    * {
      margin: 0 !important;
      font-style: italic !important;
    }
  }

  &__author {
    display: block;
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: rgba(0, 0, 0, 0.5);
    font-style: italic;
  }
}
</style>
